const getConfig = (method: 'GET' | 'POST') => ({
  method,
  headers: {
    'Content-Type': 'application/json',
  },
})

const baseUrl = `https://api.dune.com/api/v1/query`

type DuneResponse = {
  result: {
    rows: any[]
  }
}

const getTotalTransactionVolume = async () => {
  try {
    const url = `${baseUrl}/3932736/results?api_key=${process.env.REACT_APP_DUNE_API_KEY}`
    const response = await fetch(url, getConfig('GET'))
    const data = (await response.json()) as DuneResponse
    return data.result.rows[0].Total_transaction_volume
  } catch (e) {
    throw e
  }
}

const getActiveLiquiidty = async () => {
  try {
    const url = `${baseUrl}/4981971/results?api_key=${process.env.REACT_APP_DUNE_API_KEY}`
    const response = await fetch(url, getConfig('GET'))
    const data = (await response.json()) as DuneResponse
    return data.result.rows[0].active_liquidity
  } catch (e) {
    throw e
  }
}

export const protocolService = {
  getTotalTransactionVolume,
  getActiveLiquiidty,
}
